module.exports = __webpack_public_path__ + "static/media/waiting_to_be_rostered.c449915d.png";